package com.devi3east.bashbuddy.routes

import com.devi3east.bashbuddy.features.common.data.api.BASE_URL

object Routes {

    fun signUp(): String = "$BASE_URL/signup"

    fun signIn(): String = "$BASE_URL/signin"

    fun event(eventId: String, slug: String? = null): String =
        if (slug.isNullOrEmpty()) "$BASE_URL/event/$eventId"
        else "$BASE_URL/event/$eventId/$slug"

    fun stripeSuccess(
        sessionId: String,
        orgId: String,
    ): String =
        "$BASE_URL/stripe/success" +
                "?session_id=$sessionId" +
                "&org_id=$orgId"

}